import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { getAllForms, getFormById } from "../../../../../services/form.service";
import { StepContext } from "../../../../../contexts/StepContext";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  CircularProgress,
} from "@mui/material";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import { CalendarIcon } from "@heroicons/react/24/outline";
import { ModalPreviewFormJuridique } from "../../../../../components/common/Modal";
import { useQuery } from "@tanstack/react-query";

const Formulaires = () => {
  const [filter, setFilter] = useState("Brouillon");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedForms, setSelectedForms] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const { setCurrentStep, setSelectedFormId, setFormData } = useContext(StepContext);
  const navigate = useNavigate();

    const getAllformms = async () => {
      try {
        const response = await getAllForms({
          page: page + 1,
          per_page: rowsPerPage,
          searchTerm: searchQuery,
          status:filter
        });
        setTotalRows(response?.total)
        return response?.data
      } catch (error) {
        console.error("Error fetching forms:", error);
      }
    };

    const { data, isLoading } = useQuery({
      queryKey: ["listForms",searchQuery, page, rowsPerPage, filter],
      queryFn: getAllformms,
    });

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // const handleCheckboxChange = (formId) => {
  //   setSelectedForms((prevSelected) =>
  //     prevSelected.includes(formId)
  //       ? prevSelected.filter((id) => id !== formId)
  //       : [...prevSelected, formId]
  //   );
  // };

  const handleAssign = async (formId) => {
    try {
      // Fetch form details based on formId
      const selectedForm = await getFormById(formId); // Implement `getFormById` if not present
  
      // Extract the `fields` to set as `surveyData`
      const { fields } = selectedForm;
  
      // Update only the `surveyData` in `formData` while keeping other values intact
      setFormData((prevData) => ({
        ...prevData,
        surveyData: fields,
      }));
  
      // Set the selected form ID and navigate
      setSelectedFormId(formId);
      setCurrentStep(3);
      navigate("../");
    } catch (error) {
      console.error("Error fetching form details:", error);
    }
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="border rounded-lg p-3 bg-white mt-0">
      <h2 className="text-2xl font-bold text-gray-800 flex justify-center m-2">
        Assigner un formulaire
      </h2>
      <div className="bg-white border rounded-lg p-3">
        <div className="flex justify-between items-center mb-3">
          <div className="relative w-1/4">
            <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <MagnifyingGlassIcon className="h-5 w-5 text-gray-500" />
            </div>
            <input
              type="search"
              id="default-search"
              onChange={handleSearchChange}
              value={searchQuery}
              className="py-[12px] ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg focus:outline-none w-full"
              placeholder="Rechercher par titre formulaire"
            />
          </div>
          <div className="flex items-center space-x-4">
            {/* <Button className="flex items-center text-gray-600 px-4 py-2 border border-gray-300 rounded-md">
              <BsCalendar2 className="mr-2" />
              Date
            </Button> */}
            {/* <Button className="flex items-center text-gray-600 px-4 py-2 border border-gray-300 rounded-md">
              <BsFileEarmarkArrowDown className="mr-2" />
              Exporter
            </Button> */}
          </div>
        </div>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Titre formulaire</TableCell>
                <TableCell>Statut</TableCell>
                <TableCell>Date de création</TableCell>
                <TableCell>Dernière modification</TableCell>
                <TableCell>Voir formulaire</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                  <div className="p-4 justify-center items-center">
                    <CircularProgress />
                  </div>
                ) : (data?.map((form) => (
                  <TableRow
                    key={form.id}
                    className={`hover:bg-gray-50 ${
                      selectedForms.includes(form.id) ? "bg-blue-50" : ""
                    }`}
                  >
                     <TableCell>
                      {
                       form?.title
                        || "Aucun titre trouvé"}
                    </TableCell>
                    <TableCell>
                      <p className={` mt-[10px] ${form?.status === 'Publié' ? 'text-[#05CD99]' : 'text-[#FFCE20]'}`}>{form?.status}</p>
                    </TableCell>
                    <TableCell>
                         <div className="flex items-center gap-1">
                          <span className="p-1 rounded-full bg-gray-200">
                            <CalendarIcon className="h-5 w-5 text-gray-600" />
                          </span>
                        {formatDate(form.createdAt)}
                        </div>
                        </TableCell>
                    <TableCell>
                        <div className="flex items-center gap-1">
                          <span className="p-1 rounded-full bg-gray-200">
                            <CalendarIcon className="h-5 w-5 text-gray-600" />
                          </span>
                        {formatDate(form.updatedAt)}
                        </div>
                        </TableCell>
                    <TableCell>
                      <ModalPreviewFormJuridique  formString={form.fields}/>  
                    </TableCell>

                    <TableCell>
                      <button
                        onClick={() => handleAssign(form.id)}
                        className="no-underline bg-[#0976BC] hover:bg-[#065A94] transition-colors duration-300 text-white px-[12px] py-[6px] rounded-full text-xs"
                      >
                        Assigner
                      </button>
                    </TableCell>
                  </TableRow>
                )))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>

      <div className="flex justify-end space-x-4 mt-4">
        <button
          className="no-underline bg-[#0976BC] hover:bg-[#065A94] transition-colors duration-300 text-white px-[25px] py-[8px] rounded-full text-base"
          onClick={() => navigate(-1)}
        >
          Annuler
        </button>
      </div>
    </div>
  );
};

export default Formulaires;
